import ApiClientInstance from '../../common/ApiClient';

export const apiGetChangeRequests = (companyId) => ApiClientInstance.get(
  `api/accountants/company/change-requests${companyId ? `?company_id=${companyId}` : ''}`,
  undefined,
  true,
);

export const apiSendChangeRequests = (
  companyId,
  alias,
  accountId,
  transactionId,
  requestType,
) => ApiClientInstance.post(
  `api/accountants/company/change-requests${companyId ? `?company_id=${companyId}` : ''}`,
  {
    alias,
    items: [
      {
        account_id: accountId,
        transaction_id: transactionId,
        request_type: requestType,
      },
    ],
  },
  undefined,
  true,
);
